var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-flex",
    { attrs: { xs12: "" } },
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs10: "", "offset-xs1": "" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-text",
                    { staticClass: "pb-0" },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { staticClass: "pb-0", attrs: { xs7: "" } },
                            [
                              _c("v-skeleton-loader", {
                                staticClass: "pr-12",
                                attrs: { type: "card" },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-layout",
                            {
                              staticClass: "my-0",
                              attrs: { "justify-end": "true" },
                            },
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs5: "" } },
                                [
                                  _c("v-skeleton-loader", {
                                    staticClass: "my-3",
                                    attrs: { type: "sentences" },
                                  }),
                                  _c("v-skeleton-loader", {
                                    staticClass: "my-3",
                                    attrs: { type: "button" },
                                  }),
                                  _c("v-skeleton-loader", {
                                    staticClass: "my-3",
                                    attrs: { type: "button" },
                                  }),
                                  _c("v-skeleton-loader", {
                                    staticClass: "my-3",
                                    attrs: { type: "button" },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs10: "", "offset-xs1": "" } },
            [
              _c("v-skeleton-loader", {
                staticClass: "py-5",
                attrs: { type: "heading" },
              }),
              _c(
                "v-card",
                [
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { staticClass: "pb-0 my-0", attrs: { xs2: "" } },
                        [
                          _c("v-skeleton-loader", {
                            staticClass: "mx-2 my-2",
                            attrs: { type: "chip" },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-layout",
                        { staticClass: "pb-0 my-0" },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs2: "" } },
                            [
                              _c("v-skeleton-loader", {
                                staticClass: "mx-2 my-2",
                                attrs: { type: "chip" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { staticClass: "px-3", attrs: { xs12: "" } },
                    [_c("v-skeleton-loader", { attrs: { type: "table-row" } })],
                    1
                  ),
                  _c(
                    "v-flex",
                    { staticClass: "px-3", attrs: { xs12: "" } },
                    [_c("v-skeleton-loader", { attrs: { type: "table-row" } })],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs10: "", "offset-xs1": "" } },
            [
              _c("v-skeleton-loader", {
                staticClass: "py-5",
                attrs: { type: "heading" },
              }),
              _c(
                "v-card",
                [
                  _c(
                    "v-flex",
                    { staticClass: "px-3 py-5", attrs: { xs12: "" } },
                    [_c("v-skeleton-loader", { attrs: { type: "chip" } })],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs10: "", "offset-xs1": "" } },
            [
              _c("v-skeleton-loader", {
                staticClass: "py-5",
                attrs: { type: "heading" },
              }),
              _c(
                "v-card",
                [
                  _c(
                    "v-flex",
                    { staticClass: "px-3 py-5", attrs: { xs4: "" } },
                    [_c("v-skeleton-loader", { attrs: { type: "image" } })],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }